import { render } from "./PaymentFailedView.vue?vue&type=template&id=36dd3e79&scoped=true"
import script from "./PaymentFailedView.vue?vue&type=script&lang=js"
export * from "./PaymentFailedView.vue?vue&type=script&lang=js"

import "./PaymentFailedView.vue?vue&type=style&index=0&id=36dd3e79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dd3e79"]])

export default __exports__